<ui-card>
    <div class="flex col">
        <mat-form-field class="restricted-width">
            <mat-label>{{
                'time-off-v3.policyComponents.workSchedules.overallSettings.edit.workScheduleName' | translate
            }}</mat-label>
            <input
                type="text"
                matInput
                name="workScheduleName"
                placeholder="{{
                    'time-off-v3.policyComponents.workSchedules.overallSettings.edit.egWeekendWorkSchedule' | translate
                }}"
                required
                [(ngModel)]="workSchedule.name"
            />
        </mat-form-field>
        <div class="restricted-width margin-top-2">
            <mat-label
                >{{ 'time-off-v3.policyComponents.workSchedules.overallSettings.weekend' | translate }}:</mat-label
            >
            <app-day-selector [(selected)]="workSchedule.weekendDays"></app-day-selector>
        </div>
    </div>
</ui-card>
